import React, { Component } from 'react';
import Steps from '../../../components/Steps/Steps';
import { manualDataEntrySteps } from '../../../utils/constants';
import { Collapse,Row,Col,Button,Input } from 'reactstrap';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import officeCreatedIcon from './../../../assets/office_created_icon.svg';
import { YES_NO_TYPE, WEEKS_TYPE } from '../../../utils/manualEntryQuestions';

class QuestionsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapse : Array(this.props.questions.length).fill(false)
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.currentStep !== nextProps.currentStep) {
      this.setState({
        collapse : Array(this.props.questions.length).fill(false)
      });
    }
  }

  handleQuestionAnswered = ({target},o,kpi,category,isTextInput) => {
    const {name,value} = target;
    if(isTextInput) {
      if(isNaN(value) || value > 100 || value < 0) {
        return;
      }
    }
    this.props.onQuestionAnswered(value,o.text,kpi,category);
  }

  isChecked = (questionText,value) => {
    const {questionsWithAnswer} = this.props;
    const i = findIndex(questionsWithAnswer,{text : questionText, value : value});
    if(i > -1) {
      return true;
    }
    return false;
  }

  getValue = (questionText) => {
    const {questionsWithAnswer} = this.props;
    const question = find(questionsWithAnswer,{text : questionText});
    if(question) {
      return question.value;
    }
    return '';
  }

  getAnsweredCount = (kpi) => {
    const {questionsWithAnswer} = this.props;
    const questionsAnsweredForKpi = filter(questionsWithAnswer,{kpi : kpi});
    return filter(questionsAnsweredForKpi,(o) => o.value && o.value.length > 0).length;
  }

  handleCollapseToggle = (i) => {
    const {collapse} = this.state;
    collapse[i] = !collapse[i];
    this.setState({
      collapse : collapse
    });
  }

  populateQuestions = () => {
    const {collapse} = this.state;
    return this.props.questions.map((category,i) => {
      return(
        <div key={i}>
          <div className="row cursor-pointer" onClick={() => this.handleCollapseToggle(i)} key={i}>
            <div className="questions-row-title col-md-6 col-lg-6">
              {category.type}
            </div>
            <div className="questions-row-help-text col-md-5 col-lg-5">
              {
                this.getAnsweredCount(category.kpiId) === category.questions.length ?
                <div className="complete">
                  <span style={{marginRight:'10px'}}><img src={officeCreatedIcon}/></span>
                  <span>
                    ({this.getAnsweredCount(category.kpiId)} of {category.questions.length} questions answered)
                  </span>
                </div> :
                <div>
                  ({this.getAnsweredCount(category.kpiId)} of {category.questions.length} questions answered)
                </div>
              }
            </div>
            <div className={"col-lg-1 col-md-1 "+(collapse[i] == true ? 'rotate-arrow' : 'text-center')}>
              <i className="flaticon-down-arrow review-flaticon-down-arrow cursor-pointer"></i>
            </div>
          </div>
          <Collapse isOpen={collapse[i]}>
            <div>
              {
                category.questions.map((question,j) => {
                  return(
                    <div key={j}>
                      <div className="mt30 question-text">
                        {question.text}
                      </div>
                      {
                        question.optionsType === YES_NO_TYPE ?
                        <div onChange={(e) => {this.handleQuestionAnswered(e,question,category.kpiId, category.category)}}>
                          <div className={`radio`}>
                            <input id={`radio-${i}-${j}-1`} name={`radio-${i}-${j}`} 
                              type="radio" value='yes' checked={this.isChecked(question.text,'yes')}/>
                            <label htmlFor={`radio-${i}-${j}-1`} className="radio-label custom-radio-labels">
                              Yes
                            </label>
                          </div>
                          <div className="radio">
                            <input id={`radio-${i}-${j}-2`} name={`radio-${i}-${j}`} 
                              type="radio" value='no' checked={this.isChecked(question.text,'no')}/>
                            <label  htmlFor={`radio-${i}-${j}-2`} className="radio-label custom-radio-labels">
                              No
                            </label>
                          </div>
                        </div> :
                        question.optionsType === WEEKS_TYPE ?
                        <div onChange={(e) => {this.handleQuestionAnswered(e,question,category.kpiId,category.category)}}>
                          <div className={`radio`}>
                            <input id={`radio-${i}-${j}-1`} name={`radio-${i}-${j}`} 
                              type="radio" value='none' checked={this.isChecked(question.text,'none')}/>
                            <label htmlFor={`radio-${i}-${j}-1`} className="radio-label custom-radio-labels">
                              None
                            </label>
                          </div>
                          <div className="radio">
                            <input id={`radio-${i}-${j}-2`} name={`radio-${i}-${j}`} 
                              type="radio" value='1-4 weeks' checked={this.isChecked(question.text,'1-4 weeks')}/>
                            <label  htmlFor={`radio-${i}-${j}-2`} className="radio-label custom-radio-labels">
                              1-4 weeks
                            </label>
                          </div>
                          <div className="radio">
                            <input id={`radio-${i}-${j}-3`} name={`radio-${i}-${j}`} 
                              type="radio" value='5-8 weeks' checked={this.isChecked(question.text,'5-8 weeks')}/>
                            <label  htmlFor={`radio-${i}-${j}-3`} className="radio-label custom-radio-labels">
                              5-8 weeks
                            </label>
                          </div>
                          <div className="radio">
                            <input id={`radio-${i}-${j}-4`} name={`radio-${i}-${j}`} 
                              type="radio" value='>8 weeks' checked={this.isChecked(question.text,'>8 weeks')}/>
                            <label  htmlFor={`radio-${i}-${j}-4`} className="radio-label custom-radio-labels">
                              {'>'}8 weeks
                            </label>
                          </div>
                        </div> 
                        : 
                        <div className="mt10" style={{display:'flex',alignItems:'center'}}>
                          <Input type="text" style={{width:'25%'}}
                          placeholder="Enter %"
                          onChange={(e) => {this.handleQuestionAnswered(e,question,category.kpiId,category.category,true)}}
                          value={this.getValue(question.text)}/> 
                          <span className="ml5">%</span>
                        </div>
                      }
                    </div>
                  )
                })
              }
              <div className="question-clear mt30 mb10 cursor-pointer" >
                <span onClick={() => this.props.onClear(category.kpiId)}>Clear</span>
              </div>
            </div>
          </Collapse>
          <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
        </div>
      );
    });
  }

  render() { 
    // console.log(this.state.collapse);
    return ( 
      <div className="mt30">
        <div className="title-text">
          Manual Data Entry
        </div>
        <Steps
          steps={manualDataEntrySteps}
          currentStep={(this.props.currentStep - 1)}
          onStepClick={(selectedStep) => { console.log(selectedStep);
            this.props.goToStep(selectedStep)}}
        />
        <div className="mt40 manual-entry-instruction">
          Click on each section below to answer survey-like questions that are used to calculate scores 
          for that KPI. You can skip some questions or entire sections, and come back to them at a later time.
        </div>
        <div className="row mt40">
          <div className="col-md-9 col-lg-9 offset-md-1 offset-lg-1">
            {
              this.populateQuestions()
            }
          </div>
        </div>
        <Row className="mt40 clearfix mb10">
          <Col sm={{ size: "6" }}>
            <Row>
              <Col sm="6">
                <Button
                  className="float-left goBackBtn w100"
                  onClick={this.props.goBack}>
                  <span className="goBackBtnTxt">
                    <span className="ml10 flaticon-back"/> Go Back
              </span>
                </Button>
              </Col>
            </Row>
          </Col>
          <Col sm="6" md="6">
            <Row>
              <Col sm={{size: 6, offset: 6}} md={{size: 6, offset: 6}}>
                <Button className="float-right continueBtn w100" onClick={this.props.nextBtnAction}>
                  <span className="continueBtnTxt">
                    {this.props.nextBtnTxt} 
                    <span className={ 'ml10 '.concat(this.props.nxtBtnIcon)} />
                  </span>
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
 
export default QuestionsList;